import { atom } from 'recoil';
import {
  getLocalStorageValue,
  LocalStorageKey,
} from '../../utils/localStorage/localStorage';
import { LANGUAGE_LOCKED, LOCKED_LANGUAGE } from '../../../config/language';

export const selectedLanguageState = atom<string>({
  key: 'languageState',
  default: LANGUAGE_LOCKED
    ? LOCKED_LANGUAGE
    : getLocalStorageValue(LocalStorageKey.language) ?? 'GB',
});
